module.exports = __webpack_public_path__ + "static/media/mainpagesvg.b61c4fbe.svg";